export default __webpack_public_path__ + "static/media/contactHero.9a6d2cfd.png";